import React from 'react';
import _ from 'lodash';

import ga from '../../util/googleAnalytics';

import { propExistsAndNonEmpty } from '../../util/utils';

import SinglePagePromptContainer from './singlePagePrompt/singlePagePromptContainer';
import SinglePageNav from './singlePageNav/singlePageNav';

import './singlePage.scss';

class SinglePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            saveResultsConsent: false,
            isNonUs: false
        };

        this.handleConsent = this.handleConsent.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        if (propExistsAndNonEmpty(this.props.assessment)) {
            this.props.initializeFilterQueue();
        }

        if (propExistsAndNonEmpty(this.props.countryInfo)) {
            this.setState({
                isNonUs:
                    this.props.countryInfo !== 'US' &&
                    this.props.countryInfo !== 'not_set'
            });
        }

        ga.sendPageview(this.props, 'Single page quiz');

    }

    componentDidUpdate(prevProps) {
        const {
            assessment,
            countryInfo
        } = this.props;

        if (assessment !== prevProps.assessment) {
            this.props.initializeFilterQueue();
        }

        if (countryInfo !== prevProps.countryInfo) {
            this.setState({
                isNonUs: this.props.countryInfo !== 'US'
            });
        }
    }

    componentWillUnmount() {
        this.props.aggregateFilters();
        this.props.clearAllFilters();
    }

    handleConsent() {
        this.setState({ saveResultsConsent: !this.state.saveResultsConsent });
    }

    render() {
        const { prompts, assessment } = this.props;
        const { saveResultsConsent, isNonUs } = this.state;

        const saveResults = assessment?.resultsConfig?.saveResults;

        return (
            <>
                {prompts && Object.keys(prompts).length ? Object.values(prompts).map(prompt =>
                    <SinglePagePromptContainer key={prompt.id} prompt={prompt} />
                ) : null}

                <p className="prompt blurb">
                    <a
                        href={assessment.privacyPolicyUrl}
                        target="_blank"
                        className="privacy-text"
                        rel="noreferrer"
                    >
                        <span className="privacy">Privacy Policy</span>
                    </a>
                </p>

                {isNonUs && saveResults && (
                    <div className="optional-consent">
                        <label className="checkbox-text">
                            I consent to Healthline using my data to personalize my experience
                            through content and advertising
                            <input
                                type="checkbox"
                                className="checkbox"
                                id="optional-consent-checkbox"
                                name="optional-consent-checkbox"
                                value="optional-consent-checkbox"
                                onClick={this.handleConsent}
                            />
                            <span className="checkmark" />
                        </label>
                    </div>
                )}

                <SinglePageNav saveResultsConsent={saveResultsConsent || !isNonUs} />

            </>
        );
    }
}

export default SinglePage;
